import { HTTP } from '../../http-common';
import { createHelpers } from 'vuex-map-fields';
import { httpError } from '../../models/httpError';
import { getField, updateField } from 'vuex-map-fields';

const state = {
  distinctCustomers: [],
  message: new httpError(),
};

const getters = {
  message: state => {
    state.message;
  },
  distinctCustomers: state => {
    return state.distinctCustomers;
  },
  getField,
};

const mutations = {
  SET_PROGRESS(state, message) {
    state.message = message;
  },
  SET_DISTINCT_CUSTOMERS(state, data) {
    state.distinctCustomers = data;
  },
  updateField,
};

const actions = {
  async checkMissingCustomers({ commit, dispatch }) {
    try {
      const result = await HTTP.post(`pbx/CheckMissingCustomers`);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  setMessage({ commit }, message) {
    commit('SET_PROGRESS', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('SET_PROGRESS', new httpError());
      }, 2000);
  },
  async getDistinctCustomers({ dispatch, commit }) {
    try {
      let distinctCustomers = await HTTP.get('dealer/GetVoipTempCustomers');
      commit('SET_DISTINCT_CUSTOMERS', distinctCustomers.data.data);
      dispatch(
        'setMessage',
        new httpError({ message: 'Retreived OK', httpStatus: 200 })
      );
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async createCustomerLogin({ commit, dispatch }, data) {
    try {
      const result = await HTTP.post(
        'dealer/ConvertTempCustomerToDealer',
        data
      );
      Promise.resolve(result.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }

    return new Promise((resolve, reject) => {
      HTTP.post('dealer/ConvertTempCustomerToDealer', data)
        .then(res => {
          if (res.status == 200) dispatch('getDistinctCustomers');

          dispatch(
            'setMessage',
            new httpError({ message: 'Created Successfully', httpStatus: 200 })
          );
          resolve(res.data);
        })
        .catch(err => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'Error creating',
              httpStatus: 500,
            })
          );
          reject(err);
        });
    });
  },

  async updatePBXDomain({ commit, dispatch }, customerNumber) {
    try {
      let distinctCustomers = await HTTP.post(
        `pbx/UpsertPBXHostedFields`,
        customerNumber
      );
      dispatch(
        'setMessage',
        new httpError({ message: 'Update OK', httpStatus: 200 })
      );
      return distinctCustomers.data;
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
};

const modules = {};
export const { mapFields: mapDistinctCustomersFields } = createHelpers({
  getterType: `distinctCustomers/getField`,
  mutationType: `distinctCustomers/updateField`,
});

export const {
  mapMultiRowFields: mapDistinctCustomersMultiRowFields,
} = createHelpers({
  getterType: 'distinctCustomers/getField',
  mutationType: 'distinctCustomers/updateField',
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
};
